const websiteOrigin = import.meta.env.VITE_WEBSITE_URL

/** 仅用于官网相关链接，保留业务路径、查询参数及锚点。 */
export function resolveWebsiteUrl(value: string) {
  if (!websiteOrigin || !value) return value
  const url = new URL(value, window.location.origin)
  return `${websiteOrigin}${url.pathname}${url.search}${url.hash}`
}

export const siteConfig = {
  site: import.meta.env.VITE_SITE,
  websiteOrigin,
  publicHeadUrl: import.meta.env.VITE_APP_PUBLIC,
  loginUrl: import.meta.env.VITE_USER_LOGIN,
  userCenterUrl: import.meta.env.VITE_USER_CENTER,
  settlementUrl: import.meta.env.VITE_SETTLEMENT_URL,
  rechargeUrl: import.meta.env.VITE_USER_RECHARGE,
  couponUrl: import.meta.env.VITE_USER_COUPON,
}

/** 每个页面只插入一次公共头脚本。 */
export function loadPublicHeader() {
  if (!siteConfig.publicHeadUrl || document.getElementById('hgj-public-head'))
    return
  const script = document.createElement('script')
  script.id = 'hgj-public-head'
  script.src = siteConfig.publicHeadUrl
  script.async = true
  document.head.appendChild(script)
}
